// Work window data: education, experience, projects, research, certifications, skills, and services

export const EDUCATION = [
  { degree: 'Masters in Data Science', institution: 'University of Potsdam', year: 'Present' },
  { degree: 'B.Sc. CS & Software Engineering', institution: 'AIUB', year: '2021' },
]

export const EXPERIENCE = [
  { role: 'AI Innovation in Audit', company: 'KPMG', period: '2024 - Present' },
  { role: 'Data Science & AI', company: 'HPI & Mt. Sinai', period: '2024 - 2025' },
  { role: 'Full Stack xAI Dev Intern', company: 'Continental AI Lab', period: '2024' },
  { role: 'Student Research Assistant', company: 'University of Potsdam', period: '2023 - 2024' },
]

export const PROJECTS = [
  { name: 'Pre-trained Models', tech: 'PyTorch, ResNet18', status: 'Complete' },
  { name: 'Deep Learning Models', tech: 'TensorFlow, MobileNetV2', status: 'Complete' },
  { name: 'AI Survey Analysis', tech: 'OpenAI LLM, Data Viz', status: 'Complete' },
  { name: 'Bio-Statistical Analysis', tech: 'R, Regression', status: 'Complete' },
]

export const RESEARCH = [
  { title: 'Magnetic Control Track', venue: 'ICCA Conference', year: '2020' },
]

export const CERTIFICATIONS = [
  { name: 'IBM AI Engineering', issuer: 'IBM', year: 'Recent' },
  { name: 'Magna Cum Laude', issuer: 'AIUB', year: '2021' },
  { name: 'Deans List Awards', issuer: 'AIUB', year: '2021' },
]

export const SKILLS = ['Python', 'R', 'Azure AI', 'TensorFlow', 'PyTorch', 'Scikit-Learn', 'Agentic AI', 'Computer Vision', 'XAI', 'React', 'Django', 'SQL', 'Docker', 'Linux', 'Tailwind', 'Git']

export const SERVICES = [
  { title: 'AI ENGINEERING', desc: 'LLMs, Agentic Workflows, Deep Learning' },
  { title: 'DATA SCIENCE', desc: 'Data Preprocessing, Visualization, Statistics' },
  { title: 'XAI DEVELOPMENT', desc: 'Model Explainability, Transparency, Zennit' },
  { title: 'FULL-STACK DEV', desc: 'React, Django, Nicegui, Cloud Deployments' },
]
